import TimeNumber0 from 'assets/images/driving-zone/img-time-l-0.svg';
import TimeNumber1 from 'assets/images/driving-zone/img-time-l-1.svg';
import TimeNumber2 from 'assets/images/driving-zone/img-time-l-2.svg';
import TimeNumber3 from 'assets/images/driving-zone/img-time-l-3.svg';
import TimeNumber4 from 'assets/images/driving-zone/img-time-l-4.svg';
import TimeNumber5 from 'assets/images/driving-zone/img-time-l-5.svg';
import TimeNumber6 from 'assets/images/driving-zone/img-time-l-6.svg';
import TimeNumber7 from 'assets/images/driving-zone/img-time-l-7.svg';
import TimeNumber8 from 'assets/images/driving-zone/img-time-l-8.svg';
import TimeNumber9 from 'assets/images/driving-zone/img-time-l-9.svg';
import TimeNumberDot from 'assets/images/driving-zone/img-time-l-dot.svg';

const TimeNumbers = [
  TimeNumber0,
  TimeNumber1,
  TimeNumber2,
  TimeNumber3,
  TimeNumber4,
  TimeNumber5,
  TimeNumber6,
  TimeNumber7,
  TimeNumber8,
  TimeNumber9,
];

export {TimeNumbers, TimeNumber0, TimeNumber1, TimeNumber2, TimeNumber3, TimeNumber4, TimeNumber5, TimeNumber6, TimeNumber7, TimeNumber8, TimeNumber9, TimeNumberDot}